export function formataVencimento(anomes: string) {
  return `${anomes}`.substring(4, 6) + "/" + `${anomes}`.substring(0, 4);
}
